// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3Pk7K","resendInfoText":"OnGoingPaymentBox_resendInfoText__3IwXg"};